// extracted by mini-css-extract-plugin
export default {"page":"AdminProductList_page__ZnLoD","container":"AdminProductList_container__2TLgt","cardContainerWrapper":"AdminProductList_cardContainerWrapper__1W2Ox"};